module.exports = __webpack_public_path__ + "img/featured-image.4fb10da6.jpg";